export const collectionSectionStyles = {
	root: {
		display: 'flex',
		flexDirection: 'row',
		gap: 1,
		minWidth: 0
	},

	label: {
		maxWidth: '200px',
		minWidth: '200px',
		color: 'text.fadedPrimary',
		fontWeight: 700,
		fontSize: '1rem'
	},

	fieldWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1,
		width: '100%',
		minWidth: 0
	},

	cardsContainer: {
		border: '1px solid var(--mui-palette-divider)',
		borderRadius: 1,
		minWidth: 0
	},

	addButton: {
		display: 'flex',
		justifyContent: 'flex-start',
		width: 'max-content'
	}
};

export const collectionCardStyles = {
	root: {
		overflow: 'hidden',
		width: '100%'
	},

	header: (isLastItem: boolean) => ({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		p: 1.5,
		gap: 2,
		maxHeight: 48,
		cursor: 'pointer',
		borderBottom: isLastItem ? 'none' : '1px solid var(--mui-palette-divider)'
	}),

	headerContent: (hasValues: boolean, hasError: boolean) => ({
		display: 'flex',
		alignItems: 'center',
		gap: 1,
		flexGrow: 1,
		overflow: 'hidden',

		...(hasValues && {
			color: 'success.light'
		}),
		...(hasError && {
			color: 'error.main'
		})
	}),

	headerText: {
		fontWeight: 500,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		textAlign: 'left'
	},

	expandIcon: (expanded: boolean) => ({
		transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
		transition: 'transform 0.2s'
	}),

	removeButton: {
		display: 'flex',
		width: 'max-content'
	},

	content: {
		p: 2,
		borderBottom: '1px solid var(--mui-palette-divider)'
	},

	grid: {
		display: 'grid',
		gap: 1.5,
		gridTemplateColumns: { xs: '1fr' }
	}
};
